import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { APIService } from '../app/api.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from './services/common.service';
import { DataService} from 'src/app/services/data.service';
import { SuggestProfileComponent } from '../app/suggest-profile/suggest-profile.component';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent {
    title = 'ERP';
    subNetwork: boolean = false;
    subSourcing: boolean = false;
    subCRM: boolean = false;
    subERP: boolean = true;
    isShowSupport: boolean = false;
    isStorePage: boolean = false;
    isPremiumAgency: boolean = false;
    isIndianAgency: boolean = false;
    cfg_AgnCfg: any;
    @Input() suggestProfileMdlRef: any;

    constructor(private modalService: NgbModal, private apiService: APIService, private titleSer: Title, public CmnService: CommonService, private dataSer: DataService) {

    }
    openFromWindowPopup: any = this.CmnService.GetParam('S');
    rights = {
        POView: true,
        POEntry: true,
        POEdit: true,
        SOViewTypeID: 1,
        SOEntry: true,
        SOEdit: true,
        SOView: true,
        VisibleRelIDs: '',
        InqOwn: true,
        InqOthers: true,
        StrEdit: true,
        ConnEntry: true,
        ConnEdit: true,
        ConnReference: true,
        ConnInxn: true,
        ConnAppt: true,
        RcvbEntryRemind: true,
        PropEntry: true,
        PropEdit: true,
        PropViewTypeID: 1,
        UserID: 0,
        userName: '',
        SOStatusUpdate: true,
        InvoiceEntry: true,
        InvoiceEdit: true,
        QuoteEntry: true,
        QuoteEdit: true,
        FeedEntry: true,
        CtrcViewTypeID: 1,
        SprtReqViewTypeID: 1
    }

    isShowInMenu = {
        isShowYourStore: true,
        isB2BNetShow: true,
        isOrdersShow: true,
        isRecoveryShow: true,
        isNewsFeedShow: true,
        isSearchShow: true,
        isPramotion: true,
        isInquiryShow: false,
        isAppShow: true,
        isPurchaseShow: true,
        isProspectShow: true,
        isInvoiceShow: true,
        isQuotesShow: true,
        isContractShow: true,
        isSprtReqShow: true
    }

    crmRights: any = {
        propViewTypeID: 2,
        propEntry: false,
        propEdit: false,
        custViewTypeID: 2,
        custEntry: false,
        custEdit: false,
        quoteEntry: false,
        quoteEdit: false,
        ordViewTypeID: 2,
        ordeEntry: false,
        ordChange: false,
        ordStatusChng: false,
        invEntry: false,
        invEdit: false,
        invRecovery: false,
        contEntry: false,
        contUpdate: false,
        contChange: false,
        inqRes: true,
        inqSup: false,
        invoiceView: false,
        ConnViewTypeID: 0,
        SplrViewTypeID: 0
    }

    b2bRights: any = {
        conn: false,
        webStore: false,
        newsFeeds: false
    }

    erpRights: any = {
        acctRpt: false,
        vchrEntry: false,
        acctConfig: false,
        invStatus: false,
        invTran: false,
        invEntry: false,
        invRpt: false,
        invCfg: false,
        mfgMovement: false,
        mfgRpt: false,
        mfgCfg: false,
        supEntry: false,
        supChange: false,
        purOrder: false,
        purVendorInq: false,
        showERP: true,
        poEdit: false,
        poView: false,
        splrInvViewTypeID: true,
        splrInvEntry: false,
        splrInvEdit: false
    }

    fullMdlRights: any = {
        leads: false,
        quotes: false,
        orders: false,
        support: false,
        invoices: false,
        purchase: false,
        accounts: false,
        inventory: false,
        manufacturing: false,
        tasks: false
    }

    isVoucher: boolean = true;
    isStockEntry: boolean = true;
    isDefaultGrp: boolean= true; 
    agnERPRight: any = {
        EnblAccounts: false,
        EnblInventory: false,
        EnblProduction: false,
        ETS: false,
        EnblProjects: false
    }

    selectedMenu = {
        // 1- CRM, 2- Network, 3-ERP, 4- Source
        val: 1
    }

    selMenu: any = localStorage.getItem("selMenu");
    getselMenu() {
        if (this.selMenu) {
            this.selectedMenu.val = this.selMenu;
        }
    }

    isPremium = false;
    isFree = true;
    isPeachORBzvz = false;
    bzvzEdition = 0
    daysToLeftTrial = 0;
    isTrialMode = true;
    tableM: any = [];
    jarvis: Array<any> = [];
    jarvisData: any = [];
    MTbl: any = [];
    ordCookie: any = [];
    AgencyID: number = 0;
    inqCnts: number = 0;
    agencyData = {
        isAssociation: false,
        SubscriptionTypeID: 0,
        SubscriptionType: '',
        PremiumTillDT: '',
        CntInquiries: 0
    }

    isWeb: boolean = true; 
    isClosSettingShow = false;
    isPremiumAgencyPaid = false;
    isNewDsb: boolean = false;
    limitCrossed: any = {
        leads: true,
        connections: true
    }
    innerWidth: any;
    isMobileView: boolean = false;
    showOnboarding: boolean = false;
    isQikERP: boolean = false;
    modalReference: any;
    // isRenew = false;
    ngOnInit() {   

      if (this.openFromWindowPopup == 1) {
            this.isClosSettingShow = true;
          }
        
        this.isWeb = this.apiService.apiCheckWeb();
        
        let data = localStorage.getItem("Jarvis");
        if (data) {
            this.jarvis = JSON.parse(data);
            this.isNewDsb = (this.jarvis[0].AgencyIDs == '67774') && (this.jarvis[0].UserID == 73538);
        }

        var jarvis = this.apiService.getCookie('Jarvis');
        if (jarvis) {
          this.jarvisData = JSON.parse(jarvis);
        }
    
        var tblM = this.apiService.getCookie('M');
        if (tblM) {
          this.MTbl = JSON.parse(tblM);
        }

        let erpAgn: any = this.apiService.getCookie("ERP_Agn");
        if (erpAgn) {
            erpAgn = JSON.parse(erpAgn);
            if (erpAgn.length > 0) {
                this.agnERPRight.EnblAccounts = erpAgn[0].EnblAccounts;
                this.agnERPRight.EnblInventory = erpAgn[0].EnblInventory;
                this.agnERPRight.EnblProduction = erpAgn[0].EnblProduction;
                this.agnERPRight.EnblProjects = erpAgn[0].EnblProjects;
            }
        }


        this.isPremiumAgency = this.apiService.checkIsPremiumOrTrial();
        this.bzvzEdition = this.apiService.checkBzvzEdition();
        this.isIndianAgency = this.apiService.checkisIndianAgency();
        
        if(window.location.href == "https://biziverse.com/ERP" || window.location.href == "https://biziverse.com/ERP/"){
            window.location.href = "https://biziverse.com/main.html#/home";
        }

        //alert(this.isIndianAgency)
        //get agencyIDs 
        let agencyIDs = this.apiService.getCookie("M");
        if (agencyIDs) {
            var AgeTemData= JSON.parse(agencyIDs);
            this.AgencyID = AgeTemData[0].AgencyID;
            this.inqCnts = AgeTemData[0].CntInquiries;
            this.isPremiumAgencyPaid = this.apiService.checkIsPremiumPaid();
        }

        this.getMTable();
        this.setRights();
        this.getselMenu();
        this.pageTitle();
        this.getCfgAgnCfg();
        var splitUrl = (window.location.href).split('/')

        let urlIndex: number = 3;
        if(this.apiService.fn_isLiveURL() == true){
            urlIndex = 4;
        }
        if(splitUrl.length > 0){
            if(splitUrl[urlIndex] == "voucher" || splitUrl[urlIndex] == "itemEntry?S=1" || splitUrl[urlIndex] == "GroupPrefModal?context"){
              this.isVoucher = false;
              this.isStockEntry = false;
              this.isDefaultGrp = false;
            } 
            // http://localhost:4200/GroupPrefModal?context=Supplier&GrpID=0
            else{
                var splitUrl = splitUrl[urlIndex].split('?');
                if(splitUrl.length > 0){
                    if(splitUrl[0] == "voucher" || splitUrl[0] == "itemEntry?S=1" || splitUrl[0] == "GroupPrefModal"){
                        this.isVoucher = false;
                        this.isStockEntry = false;
                        this.isDefaultGrp = false;
                    }
                }
            }
        }     
        // this.isRenew = this.CmnService.checkRenewal();
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1000) {
            this.isMobileView = true;
        }
    }

    setRights() {
        let tmpRights = localStorage.getItem('J');
       
        let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
       
        if (tmpRights) {
            let rightTbl = JSON.parse(tmpRights);
            if (rightTbl.length > 0) {
                let dataTbl = rightTbl;
                let myUserID: number = this.jarvis[0].UserID;
                let adminUserID: number = this.settingRgt.adminUserID;
                // let ownRights = $.grep(rightTbl, function (o: any) { return o.UserID == myUserID && adminUserID != o.UserID });
                let ownRights = $.grep(rightTbl, function (o: any) { return o.UserID == myUserID});
                if(ownRights.length > 0 && adminUserID != myUserID){
                    let i = 0;
                    //CRM
                    this.crmRights.propViewTypeID = ownRights[i].PropViewTypeID;
                    this.crmRights.propEntry = ownRights[i].PropEntry;
                    this.crmRights.propEdit = ownRights[i].PropEdit;
                    this.crmRights.custViewTypeID = ownRights[i].CstrViewTypeID;
                    this.crmRights.custEntry = ownRights[i].CstrEntry;
                    this.crmRights.custEdit = ownRights[i].CstrEdit;
                    this.crmRights.quoteEntry = ownRights[i].QuoteEntry;
                    this.crmRights.quoteEdit = ownRights[i].QuoteEdit;
                    this.crmRights.ordViewTypeID = ownRights[i].SOViewTypeID;
                    this.crmRights.ordeEntry = ownRights[i].SOEntry;
                    this.crmRights.ordChange = ownRights[i].SOEdit;
                    this.crmRights.ordStatusChng = ownRights[i].SOStatusUpdate;
                    this.crmRights.invEntry = ownRights[i].InvoiceEntry;
                    this.crmRights.invEdit = ownRights[i].InvoiceEdit;
                    this.crmRights.invoiceView = ownRights[i].InvoiceView;
                    this.crmRights.invRecovery = ownRights[i].RcvbEntryRemind;
                    this.crmRights.contEntry = ownRights[i].CtrcEntry ? ownRights[i].CtrcEntry : false;
                    this.crmRights.contUpdate = ownRights[i].CtrcEdit ? ownRights[i].CtrcEdit : false;
                    this.crmRights.contChange = ownRights[i].CtrcStatusUpdates ? ownRights[i].CtrcStatusUpdates : false;
                    this.crmRights.inqRes = ownRights[i].InqOwn ? ownRights[i].InqOwn : false;
                    this.crmRights.inqSup = ownRights[i].SprtReqResponse ? ownRights[i].SprtReqResponse : false;
                    this.crmRights.ConnViewTypeID = ownRights[i].ConnViewTypeID;
                    this.crmRights.SplrViewTypeID = ownRights[i].SplrViewTypeID;

                    //B2B (Network)
                    this.b2bRights.conn = ownRights[i].ConnEntry;
                    this.b2bRights.webStore = ownRights[i].StrEdit;
                    this.b2bRights.newsFeeds = ownRights[i].FeedEntry;

                    //ERP
                    this.erpRights.acctRpt = ownRights[i].Accts;
                    this.erpRights.vchrEntry = ownRights[i].AcctsVchrEntry;
                    this.erpRights.acctConfig = ownRights[i].AcctsCfg;
                    this.erpRights.invStatus = ownRights[i].Inv;
                    this.erpRights.invTran = ownRights[i].InvXns;
                    this.erpRights.invEntry = ownRights[i].InvMstrs;
                    this.erpRights.invRpt = ownRights[i].InvRpts;
                    this.erpRights.invCfg = ownRights[i].InvCfg;
                    this.erpRights.mfgMovement = ownRights[i].Prd;
                    this.erpRights.mfgRpt = ownRights[i].PrdRpts;
                    this.erpRights.mfgCfg = ownRights[i].PrdCfg;
                    this.erpRights.supEntry = ownRights[i].SplrEntry;
                    this.erpRights.supChange = ownRights[i].SplrEdit;
                    this.erpRights.purOrder = ownRights[i].POEntry;
                    this.erpRights.purVendorInq = ownRights[i].InqOthers;
                    this.erpRights.poEdit = ownRights[i].POEdit;
                    this.erpRights.poView = ownRights[i].POView;
                    this.erpRights.splrInvViewTypeID = ownRights[i].SplrInvoiceViewTypeID ? ownRights[i].SplrInvoiceViewTypeID : false;
                    this.erpRights.splrInvEntry = ownRights[i].SplrInvoiceEntry ? ownRights[i].SplrInvoiceEntry : false;
                    this.erpRights.splrInvEdit = ownRights[i].SplrInvoiceEdit ? ownRights[i].SplrInvoiceEdit : false;

                    if (!this.erpRights.acctRpt && !this.erpRights.vchrEntry && !this.erpRights.acctConfig &&
                        !this.erpRights.invStatus && !this.erpRights.invTran && !this.erpRights.invEntry && !this.erpRights.invRpt && !this.erpRights.invCfg &&
                        !this.erpRights.mfgMovement && !this.erpRights.mfgRpt && !this.erpRights.mfgCfg &&
                        !this.erpRights.purOrder && !this.erpRights.purVendorInq && !this.agnERPRight.ETS && !this.erpRights.splrInvViewTypeID && 
                        !this.erpRights.splrInvEntry && !this.erpRights.splrInvEdit) {
                        this.erpRights.showERP = false;
                    }

                    console.log('erpRights', this.erpRights);
                }
                else if (adminUserID == myUserID) {
                    let i = 0;
                    
                    this.crmRights.propViewTypeID = 1;
                    this.crmRights.propEntry = true;
                    this.crmRights.propEdit = true;
                    this.crmRights.custViewTypeID = 1;
                    this.crmRights.custEntry = true;
                    this.crmRights.custEdit = true;
                    this.crmRights.quoteEntry = true;
                    this.crmRights.quoteEdit = true;
                    this.crmRights.ordViewTypeID = true;
                    this.crmRights.ordeEntry = true;
                    this.crmRights.ordChange = true;
                    this.crmRights.ordStatusChng = true;
                    this.crmRights.invEntry = true;
                    this.crmRights.invEdit = true;
                    this.crmRights.invoiceView = true;
                    this.crmRights.invRecovery = true;
                    this.crmRights.contEntry = true;
                    this.crmRights.contUpdate = true;
                    this.crmRights.contChange = true;
                    this.crmRights.inqRes = true;
                    this.crmRights.inqSup = true;
                    this.crmRights.ConnViewTypeID = 1;
                    this.crmRights.SplrViewTypeID = 1;

                    //B2B (Network)
                    this.b2bRights.conn = true;
                    this.b2bRights.webStore = true;
                    this.b2bRights.newsFeeds = true;

                    // //ERP
                    // this.erpRights.acctRpt = true;
                    // this.erpRights.vchrEntry = true;
                    // this.erpRights.acctConfig = true;
                    // this.erpRights.invStatus = true;
                    // this.erpRights.invTran = true;
                    // this.erpRights.invEntry = true;
                    // this.erpRights.invRpt = true;
                    // this.erpRights.invCfg = true;
                    // this.erpRights.mfgMovement = true;
                    // this.erpRights.mfgRpt = true;
                    // this.erpRights.mfgCfg = true;
                    // this.erpRights.supEntry = true;
                    // this.erpRights.supChange = true;
                    // this.erpRights.purOrder = true;
                    // this.erpRights.purVendorInq = true;

                    this.erpRights.acctRpt = ownRights[i].Accts;
                    this.erpRights.vchrEntry = ownRights[i].AcctsVchrEntry;
                    this.erpRights.acctConfig = ownRights[i].AcctsCfg;
                    this.erpRights.invStatus = ownRights[i].Inv;
                    this.erpRights.invTran = ownRights[i].InvXns;
                    this.erpRights.invEntry = ownRights[i].InvMstrs;
                    this.erpRights.invRpt = ownRights[i].InvRpts;
                    this.erpRights.invCfg = ownRights[i].InvCfg;
                    this.erpRights.mfgMovement = ownRights[i].Prd;
                    this.erpRights.mfgRpt = ownRights[i].PrdRpts;
                    this.erpRights.mfgCfg = ownRights[i].PrdCfg;
                    this.erpRights.supEntry = true;
                    this.erpRights.supChange = true;
                    this.erpRights.purOrder = ownRights[i].POEntry;
                    this.erpRights.purVendorInq = ownRights[i].InqOthers;
                    this.erpRights.poEdit = ownRights[i].POEdit;
                    this.erpRights.poView = ownRights[i].POView;
                    this.erpRights.splrInvViewTypeID = ownRights[i].SplrInvoiceViewTypeID ? ownRights[i].SplrInvoiceViewTypeID : false;
                    this.erpRights.splrInvEntry = ownRights[i].SplrInvoiceEntry ? ownRights[i].SplrInvoiceEntry : false;
                    this.erpRights.splrInvEdit = ownRights[i].SplrInvoiceEdit ? ownRights[i].SplrInvoiceEdit : false;

                    if (!this.erpRights.acctRpt && !this.erpRights.vchrEntry && !this.erpRights.acctConfig &&
                        !this.erpRights.invStatus && !this.erpRights.invTran && !this.erpRights.invEntry && !this.erpRights.invRpt && !this.erpRights.invCfg &&
                        !this.erpRights.mfgMovement && !this.erpRights.mfgRpt && !this.erpRights.mfgCfg &&
                        !this.erpRights.purOrder && !this.erpRights.purVendorInq && !this.agnERPRight.ETS && !this.erpRights.splrInvViewTypeID && 
                        !this.erpRights.splrInvEntry && !this.erpRights.splrInvEdit) {
                        this.erpRights.showERP = false;
                    }
                }

                // for (var i = 0; i < dataTbl.length; i++) {                
                //     if (dataTbl[i].UserID == this.jarvis[0].UserID) {
                //         this.rights.POView = dataTbl[i].POView;
                //         this.rights.POEntry = dataTbl[i].POEntry;
                //         this.rights.POEdit = dataTbl[i].POEdit;
                //         this.rights.SOViewTypeID = dataTbl[i].SOViewTypeID;
                //         this.rights.SOEntry = dataTbl[i].SOEntry;
                //         this.rights.SOEdit = dataTbl[i].SOEdit;
                //         this.rights.SOView = dataTbl[i].SOViewTypeID == 1 ? true : false;
                //         this.rights.InqOwn = dataTbl[i].InqOwn;
                //         this.rights.InqOthers = dataTbl[i].InqOthers;
                //         this.rights.ConnEntry = dataTbl[i].ConnEntry;
                //         this.rights.ConnEdit = dataTbl[i].ConnEdit;
                //         this.rights.ConnInxn = dataTbl[i].ConnInxn;
                //         this.rights.ConnAppt = dataTbl[i].ConnAppt;
                //         this.rights.RcvbEntryRemind = dataTbl[i].RcvbEntryRemind;
                //         this.rights.QuoteEntry = dataTbl[i].QuoteEntry;
                //         this.rights.QuoteEdit = dataTbl[i].QuoteEdit;
                //         this.rights.InvoiceEntry = dataTbl[i].InvoiceEntry;
                //         this.rights.InvoiceEdit = dataTbl[i].InvoiceEdit;
                //         this.rights.PropEntry = dataTbl[i].PropEntry;
                //         this.rights.PropEdit = dataTbl[i].PropEdit;
                //         this.rights.PropViewTypeID = dataTbl[i].PropViewTypeID;
                //         this.rights.StrEdit = dataTbl[i].StrEdit;
                //         this.rights.FeedEntry = dataTbl[i].FeedEntry;
                //         this.rights.CtrcViewTypeID = dataTbl[i].CtrcViewTypeID;
                //         this.rights.SprtReqViewTypeID = dataTbl[i].SprtReqViewTypeID;
                //     }
                // }
            }
                    this.fullMdlRights.leads = (this.crmRights.propViewTypeID == 1 && this.crmRights.propEntry && this.crmRights.propEdit);
                    this.fullMdlRights.quotes = (this.crmRights.quoteEntry && this.crmRights.quoteEdit);
                    this.fullMdlRights.orders = (this.crmRights.ordViewTypeID == 1 && this.crmRights.ordeEntry);
                    this.fullMdlRights.support = this.fullMdlRights.orders;
                    this.fullMdlRights.invoices = (this.crmRights.invoiceView && this.crmRights.invEntry && this.crmRights.invEdit);
                    this.fullMdlRights.purchase = (this.erpRights.splrInvViewTypeID == 1 && this.erpRights.splrInvEntry && this.erpRights.splrInvEdit);
                    this.fullMdlRights.accounts = (this.agnERPRight.EnblAccounts && this.erpRights.acctRpt && this.erpRights.vchrEntry && this.erpRights.acctConfig);
                    this.fullMdlRights.inventory = (this.agnERPRight.EnblInventory && this.erpRights.invRpt);
                    this.fullMdlRights.manufacturing = (this.agnERPRight.EnblProduction && this.erpRights.mfgCfg);
                    this.fullMdlRights.tasks = (this.agnERPRight.ETS);

            // Connections
            if (!this.rights.ConnEntry && !this.rights.ConnEdit) {     // $scope.rights.ConnInxn || $scope.rights.ConnAppt
                this.isShowInMenu.isB2BNetShow = false;
            }

            //Purchases
            if (!this.rights.POEntry && !this.rights.POEdit) {
                this.isShowInMenu.isPurchaseShow = false;
            }

            //Inquiry
            if (this.rights.InqOwn && this.inqCnts > 0 && (this.crmRights.propViewTypeID == 1 ||  this.crmRights.custViewTypeID == 1)) {
                this.isShowInMenu.isInquiryShow = true;
            }

            //Appointment
            if (!this.rights.ConnAppt) {
                this.isShowInMenu.isAppShow = false;
            }

            //Recovery
            if (!this.rights.RcvbEntryRemind) {
                this.isShowInMenu.isRecoveryShow = false;
            }

            //your store
            if (!(this.rights.StrEdit)) {
                this.isShowInMenu.isShowYourStore = false;
            }

            //Newsfeed
            if (!(this.rights.FeedEntry)) {
                this.isShowInMenu.isNewsFeedShow = false;
            }

            //Contract
            if (this.rights.CtrcViewTypeID == 2) {
                this.isShowInMenu.isContractShow = false;
            }

            //Support req
            if (this.rights.SprtReqViewTypeID == 0) {
                this.isShowInMenu.isSprtReqShow = false;
            }
        }
    }

    getMTable() {
        let agencyData1 = localStorage.getItem("M");
        if (agencyData1) {
            var tempagencyData = JSON.parse(agencyData1);
            this.tableM = tempagencyData;
            if (tempagencyData.length > 0) {
                // Check for QikERP logo
                const createdDT = tempagencyData[0].CreatedDT;
                const subUpgradeDT = tempagencyData[0].SubUpgradedDT;
                const fromDT = "2026-02-26T00:00:00";
                if ((createdDT && createdDT >= fromDT) || (subUpgradeDT && subUpgradeDT >= fromDT)) {
                    this.isQikERP = true;
                }

                this.agencyData.isAssociation = tempagencyData[0].IsAssociation;
                this.settingRgt.adminUserID = tempagencyData[0].AdminUserID;
                this.agencyData.SubscriptionTypeID = tempagencyData[0].SubscriptionTypeID;
                this.agencyData.SubscriptionType = tempagencyData[0].SubscriptionType;
                this.agencyData.PremiumTillDT = tempagencyData[0].PremiumTillDT;
                this.agencyData.CntInquiries= tempagencyData[0].CntInquiries;
                this.agnERPRight.ETS = tempagencyData[0].ETS ? tempagencyData[0].ETS : false;
                if (this.agencyData.SubscriptionTypeID == 2 && this.agencyData.SubscriptionType == 'Trial') {
                    this.isPremium = false;
                    this.isFree = false;
                    this.getDays(tempagencyData[0].PremiumTillDT);
                }
                else if (this.agencyData.SubscriptionTypeID == 3 && this.agencyData.SubscriptionType == 'Premium') {
                    this.isPremium = true;
                    this.isFree = false;
                    this.getDays(tempagencyData[0].PremiumTillDT);
                }
                else if (this.agencyData.SubscriptionTypeID == 1 && this.agencyData.SubscriptionType == 'Free') {
                    this.isFree = true;
                    this.isPremium = false;
                    this.getDays(tempagencyData[0].PremiumTillDT);
                }

                let isShowBecomePremiumMember = localStorage.getItem("isShowBecomePremiumMember");
                localStorage.removeItem("isShowBecomePremiumMember");
                if (this.agencyData.SubscriptionType != 'Premium' && isShowBecomePremiumMember && isShowBecomePremiumMember != null) {
                    //this.openToBecomePremiumMember();
                }

                if (this.tableM[0].FirstUpgdDT) {
                    if (this.addDays(new Date(this.tableM[0].FirstUpgdDT), 7) > new Date()) {
                        this.showOnboarding = true;
                    }
                }
                this.isMgrnDone = tempagencyData[0].MgrnDone;
                this.leadsPath = this.isMgrnDone ? '/CRM' : '/leads';
            }
            if (this.settingRgt.adminUserID == this.jarvis[0].UserID) {
                this.settingRgt.isShowSetting = true;
            }
           else{
            this.settingRgt.isShowSetting = false;
           }
        }
    }



    //isShowInMenu = {
    //  isShowYourStore: true,
    //  isB2BNetShow: true,
    //  isOrdersShow: true,
    //  isRecoveryShow: true,
    //  isNewsFeedShow: true,
    //  isSearchShow: true,
    //  isPramotion: true,
    //  isInquiryShow: true,
    //  isAppShow: true,
    //  isPurchaseShow: true
    //}

    settingRgt = {
        isShowSetting: false,
        adminUserID: 0,
        myUserID: 0
    }
    isMgrnDone = false;
    leadsPath = '/leads';
    
    openIntroLink(moduleID: any, deviceType: any ){
        var isBlank = this.isWeb ? '_blank' : '_self';
        var introURL = "https://Biziverse.com/intro.html?u=" + moduleID + "&d=" + deviceType;
        window.open(introURL, isBlank, "height = 600, width = 1050");
    }

    //actionMenu
    actionMenu(id: any) {
        let url = '../../main.html#/';
        if (id == 0) {
            window.location.href = url + 'home';
            this.isStorePage = false;
        }
        else if (id == 7) {
            window.location.href = url + 'Network';
            this.isStorePage = false;
            localStorage.setItem("state", 'c')
        }
        else if (id == 8) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                localStorage.setItem("state", 'b');
                window.location.href = url + 'Appointments';
            }
        }
        else if (id == 9) {
            window.location.href = url + 'Feed';
            this.isStorePage = false;
        }
        else if (id == 6) {
            window.location.href = url + 'Store';
            this.isStorePage = true;
        }
        else if (id == 13) {
            window.location.href = url + 'Settings';
            this.isStorePage = false;
        }
        else if (id == 11) {
            window.location.href = url + 'Search';
            this.isStorePage = false;
        }
        else if (id == 15) {
            window.location.href = url + 'Purchase';
            localStorage.setItem("ordType", 'p')
            this.isStorePage = false;
        }
        else if (id == 21) {
            // window.location.href = url + 'Kanban';
            // this.isStorePage = false;
            if(this.isPremiumAgency == false){
                this.openIntroLink(2,'w');
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'Kanban';
            }
        }
        else if (id == 22) {
            if(this.isPremiumAgency == false){
                this.openIntroLink(3,'w');
               // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
        }
        else if (id == 29) {        
            if(this.isPremiumAgency == false){
                this.openIntroLink(1,'w');
               // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
        }
        else if (id == 2) {
            this.isTrialMode = true;
            window.location.href = "../../main.html#/orders?ID=sup";

            // window.location.href = url + 'Inquiry';
            // this.isStorePage = false;
            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         window.location.href = "../../main.html#/orders?ID=sup";
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     window.location.href = "../../main.html#/orders?ID=sup";
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 16) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'Docs?M=7';
            }
            
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         window.location.href = url + 'Docs?M=7';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     window.location.href = url + 'Docs?M=7';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 1) {
            if(this.isPremiumAgency == false){
                this.openIntroLink(4,'w');
                // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isTrialMode = true;
                localStorage.setItem("ordType", 's')
                window.location.href = "main.html#/orders";
            }
            // this.isTrialMode = true;
            // localStorage.setItem("ordType", 's')
            // window.location.href = "main.html#/orders";

            //this.isStorePage = false;
            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         //this.sucessSubscription()
            //         //{
            //         //    localStorage.setItem("ordType", 's')
            //         //    window.location.href = "main.html#/orders";
            //         //    window.location.reload();
            //         //}
            //         localStorage.setItem("ordType", 's')
            //         window.location.href = url + 'orders';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     localStorage.setItem("ordType", 's')
            //     window.location.href = "../../main.html#/orders";
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 24) {
            if(this.isPremiumAgency == false){
                this.openIntroLink(5,'w');
                // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isTrialMode = true;
                window.location.href = url + 'Invoices';
            }
            // if(this.isPremiumAgency == false){
            //     window.location.href = url + 'home?isUpMdl=1'
            //     return;
            // }
            // else{
            //     window.location.href = url + 'Invoices';
            // }
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         window.location.href = url + 'Invoices';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     window.location.href = url + 'Invoices';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 5) {

            this.isTrialMode = true;
            localStorage.setItem("state", 'R')
            window.location.href = url + 'Network';
            
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         localStorage.setItem("state", 'R')
            //         window.location.href = url + 'Network';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     localStorage.setItem("state", 'R')
            //     window.location.href = url + 'Network';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 18) {
            if(this.isPremiumAgency == false){
                this.openIntroLink(7,'w');
                // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isTrialMode = false;
                window.location.href = url + 'Contracts';
            }
            //this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         window.location.href = url + 'Contracts';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     window.location.href = url + 'Contracts';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 17) {
            window.location.href = url + 'Inquiry';
            this.isStorePage = false;

            if (id == 18) {

                this.isTrialMode = true;
                        localStorage.setItem("inqType", 'i')
                        window.location.href = url + 'Contracts';
                window.location.href = url + 'Inquiry';
                this.isStorePage = false;

                if (this.agencyData.PremiumTillDT == null) {
                    if (confirm("Would you like to start your free trial?")) {
                        this.isTrialMode = true;
                        localStorage.setItem("inqType", 'i')
                        window.location.href = url + 'Contracts';
                        window.location.reload();
                    }
                }
                else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
                    this.isTrialMode = false;
                    localStorage.setItem("inqType", 'i')
                    window.location.href = url + 'Inquiry';
                    window.location.reload();
                }
                else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
                    this.isTrialMode = false;
                    alert("Sorry!  Your Biziverse Premium subscription has ended.");
                    return;
                }
            }
        }
        else if (id == 26) {
            //window.location.href = '/accounts';
            this.apiService.setCookie("slectedHeadID", 0);
            this.apiService.setCookie("slectedLeaderID", 0);
            if(this.isPremiumAgencyPaid == false){
                this.openIntroLink(9,'w');
                // window.location.href = '/accounts';
                return;
            }
            // this.isStorePage = false;
            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         this.erpLeads('Account', 'tried to use Account module', 'accounts', function () {
            //             window.location.href = "accounts";
            //         });
            //     };
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     this.erpLeads('Account', 'tried to use Account module', 'accounts', function () {
            //         window.location.href = "accounts";
            //     });
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     window.location.href = url + 'home';
            //     return;
            // }
        }
        else if (id == 27) {
            if(this.isPremiumAgencyPaid == false){
                this.openIntroLink(10,'w');
                // window.location.href = '/Stock';
                return;
            }
            // window.location.href = '/Stock';
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         this.erpLeads('Stock', 'tried to use Stock module', 'Stock', function () {
            //             window.location.href = "Stock";
            //         });
            //     };
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     this.erpLeads('Stock', 'tried to use Stock module', 'Stock', function () {
            //         window.location.href = "Stock";
            //     });
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     window.location.href = url + 'home';
            //     return;
            // }
        }
        else if (id == 28) {
            if(this.isPremiumAgencyPaid == false){
                this.openIntroLink(11,'w');
                // window.location.href = '/ProductionList';
                return;
            }
            //  window.location.href = '/ProductionList';
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         this.erpLeads('Production', 'tried to use Production module', 'ProductionList', function () {
            //             window.location.href = "ProductionList";
            //         });
            //     };
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     this.erpLeads('Production', 'tried to use Production module', 'ProductionList', function () {
            //         window.location.href = "ProductionList";
            //     });
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     window.location.href = url + 'home';
            //     return;
            // }
        }
        else if (id == 30) {
            this.isTrialMode = true;
            localStorage.setItem("ordType", 'p');
            window.location.href = url + 'Purchase';
            // window.location.href = url + 'Purchase';
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         localStorage.setItem("ordType", 'p');
            //         window.location.href = url + 'Purchase';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     localStorage.setItem("ordType", 'p');
            //     window.location.href = url + 'Purchase';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 31) {
            if(this.isPremiumAgency == false){
                this.openIntroLink(8,'w');
                // window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isTrialMode = false;
                window.location.href = url + 'orders?ID=sup';
            }
            // this.isTrialMode = true;
            // window.location.href = url + 'orders?ID=sup';
            //this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         // localStorage.setItem("ordType", 'p');
            //         window.location.href = url + 'orders?ID=sup';
            //         window.location.reload();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     // localStorage.setItem("ordType", 'p');
            //     window.location.href = url + 'orders?ID=sup';
            //     window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 32) {
            this.isTrialMode = true;
            this.sucessSubscription();

            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //        this.sucessSubscription();
            //     }
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     this.sucessSubscription();
            //     // window.location.href = url + 'Inquiry';
            //     // window.location.reload();
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     return;
            // }
        }
        else if (id == 34) {
            this.isTrialMode = false;
            window.location.href = "Tasks";
            // this.erpLeads('Tasks', 'tried to use Task module', 'Tasks', function () {
            //     window.location.href = "Tasks";
            // });
                    
            //  window.location.href = '/ProductionList';
            // this.isStorePage = false;

            // if (this.agencyData.PremiumTillDT == null) {
            //     if (confirm("Would you like to start your free trial?")) {
            //         this.isTrialMode = true;
            //         this.erpLeads('Tasks', 'tried to use Task module', 'Tasks', function () {
            //             window.location.href = "Tasks";
            //         });
            //     };
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) > new Date()) {
            //     this.isTrialMode = false;
            //     this.erpLeads('Tasks', 'tried to use task module', 'Tasks', function () {
            //         window.location.href = "Tasks";
            //     });
            // }
            // else if (new Date(this.agencyData.PremiumTillDT) < new Date()) {
            //     this.isTrialMode = false;
            //     alert("Sorry!  Your Biziverse Premium subscription has ended.");
            //     window.location.href = url + 'home';
            //     return;
            // }
        }
        else if (id == 36) {
            if(this.isPremiumAgencyPaid == false){
                this.openIntroLink(11,'w');
                // window.location.href = '/ProductionList';
                return;
            }
        }
        else if (id == 37) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'Docs?M=6';
            }
        }
        else if (id == 38) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'Docs?M=8';
            }
        }
        else if (id == 39) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'ConnectionEntry?t=s';
            }
        }
        else if (id == 40) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1'
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'ConnectionEntry?t=c';
            }
        }
        else if (id == 50) {
            if(this.isPremiumAgency == false){
                window.location.href = url + 'home?isUpMdl=1';
                return;
            }
            else{
                this.isStorePage = false;
                window.location.href = url + 'Reports';
            }
        }
    }

    sucessSubscription(){
        localStorage.setItem("inqType", 's')
        window.location.href = "main.html#/Inquiry";
        window.location.reload();    
    }

    showSubNetwork() {
        this.subNetwork = true;
        this.subSourcing = false;
        this.subCRM = false;
        this.subERP = false;
        this.selectedMenu.val = 2;
        let setMenu = localStorage.setItem('selMenu', '');
        setMenu = localStorage.setItem('selMenu', this.selectedMenu.val + '');
    }


    showSubSource() {
        this.subNetwork = false;
        this.subSourcing = true;
        this.subCRM = false;
        this.subERP = false;
        this.selectedMenu.val = 4;
        let setMenu = localStorage.setItem('selMenu', '');
        setMenu = localStorage.setItem('selMenu', this.selectedMenu.val + '');
    }


    showSubCRM() {
        this.subNetwork = false;
        this.subSourcing = false;
        this.subCRM = true;
        this.subERP = false;
        this.selectedMenu.val = 1;
        let setMenu = localStorage.setItem('selMenu', '');
        setMenu = localStorage.setItem('selMenu', this.selectedMenu.val + '');
    }

    showSubERP() {
        this.subNetwork = false;
        this.subSourcing = false;
        this.subCRM = false;
        this.subERP = true;
        this.selectedMenu.val = 3;
        let setMenu = localStorage.setItem('selMenu', '');
        setMenu = localStorage.setItem('selMenu', this.selectedMenu.val + '');
    }

    comingSoon() {
        alert("Coming Soon!");
        let url1 = '../../main.html#/home';
        window.location.href = url1;
       // return;
    }

    refresh = () => {
        let data = localStorage.getItem("Jarvis");
        let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
        if (data) {
            let jarvis = JSON.parse(data);
            let myParams = [{
                myUserID: jarvis[0].UserID,
                myToken: jarvis[0].WebToken,
                forAgencyID: jarvis[0].AgencyIDs,
                myAgencyIDs: jarvis[0].AgencyIDs,
                myLastSyncDT: MyLastSyncDT,
                isWeb: true,
                data: '[]'
            }];

            //$biziverse.sendChange(myParams, function () { window.location.reload(); });
        }
    }

    //logOut() - logout Function
    logOut = () => {
        this.apiService.swalConfirm("Are you sure you wish to logout?", () => {
            this.apiService.resetEverthing();
            //localStorage.clear();
            window.location.href = 'https://biziverse.com/';
            let data = localStorage.getItem("Jarvis");
            let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")
            if (data) {
                let jarvis = JSON.parse(data);
                let myParams = [{
                    myUserID: jarvis[0].UserID,
                    myToken: jarvis[0].WebToken,
                    forAgencyID: jarvis[0].AgencyIDs,
                    myAgencyIDs: jarvis[0].AgencyIDs,
                    myLastSyncDT: MyLastSyncDT,
                    isWeb: true,
                    data: '[]'
                }];

            }
        });
    }

    openMenu(id: number) {
        if (id == 1) {

        }
    }

    getDays(PremiumTillDT: any) {
        if (PremiumTillDT) {
            var date1: any = new Date();
            var date2: any = new Date(PremiumTillDT);

            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

            if (new Date() < new Date(PremiumTillDT)) {
                const diffDays = Math.round(Math.abs((date1 - date2) / oneDay));
                if (diffDays < 0) {
                    this.daysToLeftTrial = 0;
                }
                else {
                    this.daysToLeftTrial = diffDays;
                }
            }
        }
    }


    erpLeads(moduleName: any, msg: any, path: any, callback: any) {
        var tempData = [{
            'msg': this.tableM[0].Name + ' from ' + this.tableM[0].AgencyName + ' ' + msg + '. https://wa.me/91' + this.tableM[0].Mobile,
            'Module': moduleName,
            'Name': this.tableM[0].Name,
            'AgencyName': this.tableM[0].AgencyName,
            'Mobile': this.tableM[0].Mobile,
            'Email': this.tableM[0].Email,
            'forAgencyID': this.tableM[0].AgencyID,
            'userID': this.jarvis[0].UserID
        }];

        var myParams = [{
            myUserID: this.jarvis[0].UserID,
            myToken: this.jarvis[0].WebToken,
            forAgencyID: this.jarvis[0].AgencyIDs,
            myAgencyIDs: this.jarvis[0].AgencyIDs,
            myLastSyncDT: localStorage.getItem("MyLastSyncDT"),
            isWeb: true,
            data: JSON.stringify(tempData),
            actionType: 'erpLead',
            moduleID: 90
        }];

        var response = this.apiService.sendChange(myParams, callback(), this.failureERPLeads.bind(this));

    }


    //Successs resp
    successERPLeads(callBack: any, res: any) {
        if (res.error) {
           
        }
        else {
            callBack();
            //window.location.href = "ERP/" + path;
        }
    }

    //failureResp - failure handler
    failureERPLeads(res: any) {
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

    //sucessSubscription() {
    //    var tempData = [{
    //        paymentRef: '',
    //        GSTIN: this.tableM[0].GSTIN,
    //        IsTrial: true,
    //        ownName: this.jarvis[0].UserName,
    //        ownAgnName: this.tableM[0].AgencyName,
    //        ownMobile: this.tableM[0].Mobile
    //    }]

    //    let myParams = [{
    //        myLastSyncDT: localStorage.getItem("MyLastSyncDT"),
    //        myUserID: this.jarvis[0].UserID,
    //        myToken: this.jarvis[0].WebToken,
    //        forAgencyID: this.jarvis[0].AgencyIDs,
    //        myAgencyIDs: this.jarvis[0].AgencyIDs,
    //        ForERPAgencyID: this.tableM[0].ERPAgencyID,
    //        isWeb: true,
    //        moduleID: 24,
    //        actionType: 'setSub',
    //        data: JSON.stringify(tempData)
    //    }];

    //    this.apiService.sendChange(myParams, this.successSetSub.bind(this), this.failSetSub.bind(this));
    //}

    //    //Successs resp
    //    successSetSub(res: any) {
    //        if (res.error) {
    //            console.log(res.message);
    //        }
    //        else {
    //            // alert("Updated.");
    //        }
    //    }

    //    //failureResp - failure handler
    //    failSetSub(res: any) {
    //        if (res.error) {
    //            console.log(res.message);
    //        }
    //        else {
    //            alert(res.message);
    //        }
    //    }


    openSubMdl() {
        let url1 = '../../main.html#/home?id=erp';
        window.location.href = url1;
    }

    openHelp(){
        window.open("https://biziverse.com/Html/External/RequestSupport.html", "_blank", "height = 385, width = 900");
    }

    pageTitle(){
        setTimeout(() => {
            var header = $('.lblHeader').text();
            if(!header){
                header = "Biziverse"
            }
            else{
                header = header + " - Biziverse";
            }
            this.titleSer.setTitle(header);
        }, 200);
        
    }

    RefreshPage(){
        window.location.reload();
    }

    changePassword(){      
        let url1 = '../../main.html#/home?cp=1';
        window.location.href = url1;        
    }

    addDays(date: Date, days: number): Date {
        let result = new Date(date);
        result.setDate(date.getDate() + days);
        return result;
    }

    getCfgAgnCfg() {
        this.cfg_AgnCfg = localStorage.getItem("Cfg_AgnCfg");
        if (this.cfg_AgnCfg) {
            this.cfg_AgnCfg = JSON.parse(this.cfg_AgnCfg);
            if (this.cfg_AgnCfg && this.cfg_AgnCfg.length > 0) {
                // Check limits for leads and connections
                this.limitCrossed.leads = true;
                if (this.tableM[0].CntMaxLeads >= this.cfg_AgnCfg[0].CntLeads) {
                    this.limitCrossed.leads = false;
                }
                if (this.tableM[0].CntMaxConns >= this.cfg_AgnCfg[0].CntConns) {
                    this.limitCrossed.connections = false;
                }
            }
        }
    }

    // Open Upgrade Subscription Popup
    openUpgrade(id: number) {
        if (this.isMobileView) {
            window.location.href = "../../main.html#/Upgrade?i=" + id + "&z=1&v=2";
            return;
        }
        else {
            window.open("https://biziverse.com/main.html#/Upgrade?i=" + id + "&z=1&v=2", '_blank', 'height = 750, width = 1050,resizable=false, menubar=no');
        }
    }

    redirectToEntry (type: number) {
        if (!this.isPremiumAgencyPaid) {
            this.isTrialMode = true;
            this.openSubMdl();
            return;
        }
        this.getCfgAgnCfg();
        let url = '../../main.html#/';
        switch (Number(type)) {
            case 0:
                window.location.href = url + "home";
                break;
            case 1:
                if (this.limitCrossed.leads) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "LeadEntry";
                break;
            case 2:
                if(this.limitCrossed.connections) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                } else {
                    window.location.href = url +  "ConnectionEntry?t=p";
                }
                break;
            case 3:
                window.location.href = url + "DocBuilder?isN=1&Type=" + decodeURI("Quotation");
                window.location.reload();
                break;
            case 4:
                window.location.href = url + "DocBuilder?isN=1&Type=Sales Order";
                window.location.reload();
                break;
            case 5:
                window.location.href = url + "DocBuilder?isN=1&Type=" + decodeURI("Invoices");
                window.location.reload();
                break;
            case 6:
                if (this.limitCrossed.connections) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "ConnectionEntry?t=c";
                break;
            case 7:
                window.location.href = url + "ContractEntry";
                break;
            case 8:
                window.location.href = url + "SupportTicketEntry";
                break;
            case 9:
                if (this.limitCrossed.connections) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "ConnectionEntry?t=c";
                break;
            case 10:
                if (this.isMobileView) {
                    window.open('voucher', '_self');
                } 
                else {
                    window.open('voucher', '_blank', 'height = 600, width = 1250');
                }
                break;    
            case 11:
                window.location.href = url + "DocBuilder?isN=1&Type=Supplier Invoices";
                window.location.reload();
                break;
            case 12:
                window.location.href = url + "DocBuilder?isN=1&Type=Purchase Order";
                window.location.reload();
                break;
            case 13:
                window.location.href = "itemEntry?S=2";
                break;
            case 14:
                window.location.href = "ProductionList";
                break;
            case 15:
                window.location.href = "Tasks";
                break;
            case 16:
                if (this.limitCrossed.connections) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "Network?st=c&ut=4";
                window.location.reload();
                break;
            case 17:
                if (this.limitCrossed.leads) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "ConnectionEntry?t=s";
                break;
            case 18:
                if (this.limitCrossed.leads) {
                    if (confirm("You have exceeded the maximum limit of connections.<br>Would you like to upgrade the limits of connections?")) {
                        this.openUpgrade(8);	
                    }
                }
                window.location.href = url + "LeadsHome?from=dsbd";
                break;
            case 19:
                window.location.href = "TaskEntry?T=1";
                break;
            case 20:
                window.location.href = "TaskEntry?T=2";
                break;
            default:
                return window.location.href = url + "home";
        }
        return;
    }

    askIfFirstDoc =  (typeID: number, goTo: string) => {
        var amtBilling: number = 0;
        var cntQuotes: number = 0;
        var cntOrders: number = 0
        var hasDocAdded: boolean = true;
        // Check if any document is added
        this.getCfgAgnCfg();
        if (this.cfg_AgnCfg) {
            var currYY = new Date().getFullYear();
            var currMM = new Date().getMonth() + 1;
            if (this.cfg_AgnCfg.length > 0) {
                if (this.cfg_AgnCfg[0].MonthlyBilling) {
                    var mthlBilling: any = JSON.parse(this.cfg_AgnCfg[0].MonthlyBilling);
                    if (mthlBilling.length > 0) {
                        mthlBilling = $.grep(mthlBilling, function (o: any) { return o.YY == currYY && o.MM == currMM });
                        if (mthlBilling.length > 0) {
                            amtBilling = mthlBilling[0].Amt;
                        }
                    }
                }
                if (this.cfg_AgnCfg[0].MonthlyQuotes) {
                    var mthlQuotes: any = JSON.parse(this.cfg_AgnCfg[0].MonthlyQuotes);
                    if (mthlQuotes.length > 0) {
                        mthlQuotes = $.grep(mthlQuotes, function (o: any) { return o.YY == currYY && o.MM == currMM });
                        if (mthlQuotes.length > 0) {
                            cntQuotes = mthlQuotes[0].Cnt;
                        }
                    }
                }
                cntOrders = this.cfg_AgnCfg[0].CntPndgSOs ? this.cfg_AgnCfg[0].CntPndgSOs : 0;
            }
        }

        if (amtBilling == 0 && cntQuotes == 0 && cntOrders == 0) {  
            hasDocAdded = false;
        }

        // Check if all details are added
        let mCookie: any = localStorage.getItem('M');
        let tblM = []
        let allInfoAdded = false;
        if (mCookie) {
            mCookie = JSON.parse(mCookie);
            if (mCookie.length > 0) {
                tblM = mCookie;
            }
        }
        if (tblM.length > 0) {
            allInfoAdded = (tblM[0].AgencyName && tblM[0].Logo && tblM[0].GSTIN && tblM[0].State && tblM[0].StateID &&
                tblM[0].City && (tblM[0].AddressL1 || tblM[0].AddressL2) && tblM[0].DigiSign) ? true : false;
        }

        if (this.showOnboarding && !hasDocAdded && this.jarvis[0].UserID == this.settingRgt.adminUserID && !allInfoAdded) {
            let docName = (typeID == 3 ? 'Quotation' : typeID == 5 ? 'Invoice' : typeID == 11 ? 'Supplier Invoice' : typeID == 12 ? 'Purchase Order' : 
                        typeID == 4 ? 'Sales Order' : '')
            this.modalReference = this.modalService.open(SuggestProfileComponent, { windowClass: 'modal-suggest-profile', backdrop: 'static', keyboard: false });
            this.modalReference.componentInstance.suggestProfileMdlRef = this.modalReference;
            this.modalReference.componentInstance.isPremiumAgencyPaid = this.isPremiumAgencyPaid;
            this.modalReference.componentInstance.limitCrossed = this.limitCrossed;
            this.modalReference.componentInstance.tableM = this.tableM;
            this.modalReference.componentInstance.redirectToDoc = this.redirectToEntry;
            this.modalReference.componentInstance.openSubMdl = this.openSubMdl;
            this.modalReference.componentInstance.getCfgAgnCfg = this.getCfgAgnCfg;
            this.modalReference.componentInstance.openUpgrade = this.openUpgrade;

            let docInfo = {
                actionMenuID: typeID,
                docName: docName
            }
            this.dataSer.updateDocID(docInfo)
            return;
        }
        if (goTo == 'list') {
            this.actionMenu(typeID)
        }
        else {
            this.redirectToEntry(typeID);
        }
    }
}


